export const checkSampleRate = (rate = 1.0) => {
  let value = rate

  if (rate < 0) value = 0
  if (rate > 1) value = 1

  return Math.random() <= value
}
